import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceImageCreateAction from './machineServiceImageCreate.action.json' with { type: 'json' }
import { machineServiceImageCreateInputObject } from '../machineServiceImageObject'

const machineServiceImageCreateDefinition = defineAction({
  ...machineServiceImageCreateAction,

  input: machineServiceImageCreateInputObject,
  output: z.object({
    uploadUrl: z.string().nullish(),
    publicUrl: z.string().nullish(),
  }),
})

export default machineServiceImageCreateDefinition
